// Lädt eine vom Backend gelieferte Binärdatei (z. B. PDF) direkt über den Browser
// herunter, ohne ein separates Fenster/Tab zu öffnen, das offen bleibt.
export const downloadFileFromApi = async (api, endpoint, fallbackFileName) => {
  const response = await api.fetchRaw(endpoint, { method: "GET" });
  const blob = await response.blob();
  const disposition = response.headers.get("content-disposition") || "";
  const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
  const fileName = fileNameMatch ? fileNameMatch[1] : fallbackFileName;

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
